<template>
    <div class="add-report-sms">
        <h2>Wprowadź kod SMS wysłany na podany nr telefonu</h2>
        <div class="flex">
            <EonInputText v-model="smsCode" label="Kod SMS" class="flex-1"
                          name="smsCode" />
            <button type="button" class="resend-button" :disabled="startTimer" @click="resend">
                {{ startTimer ? `Wyślij ponownie za: (${timer})` : 'Wyślij kod ponownie' }}
            </button>
        </div>
        <div class="add-report-description-buttons">
            <EonOutlinedButton class="turquoise-button" label="Powrót" @click="goBack"/>
            <EonButton class="red-button wide-button" :disabled="!isDisabled || blockSubmit"
                       label="Zgłoś awarię" @click="submit" :extension="extension"/>
        </div>
    </div>
</template>

<script>
    import {FontUtils} from "@/utils/FontUtils";
    import EonInputText from "@/components/form/EonInputText";
    import EonButton from "@/components/form/EonButton";
    import EonOutlinedButton from "@/components/form/EonOutlinedButton";
    import {
        verifyValidity,
    } from "@/swagger/vue-api-client";

    export default {
        name: "AddUserReportSMS",
        components: {
            EonInputText,
            EonButton,
            EonOutlinedButton,
        },
        emits: [],
        props: {
            report: null,
            blockSubmit: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                smsCode: "",
                timer: 60,
                startTimer: false,
                fontSize: FontUtils.getFontSize(),
            };
        },
        mounted() {
            this.unsubscribe = FontUtils.onChange((size) => {
                this.fontSize = size;
            });
        },
        beforeUnmount() {
            if (this.unsubscribe) this.unsubscribe();
        },
        methods: {
            submit(e) {
                this.isSubmitting = true;
                e.preventDefault();
                this.$emit("smsCheck", {
                    smsCode: this.smsCode,
                });
                this.$emit("submitReport");
            },
            goBack() {
                this.$router.replace({name: "publicAddReportCheck"});
            },
            resend() {
                verifyValidity({phoneNumber: this.report.phoneNumber.replace("+48", "")});
                this.startTimer = true;
                const countdown = setInterval(() => {
                    this.timer -= 1;
                    if (this.timer <= 0) {
                        clearInterval(countdown);
                        this.startTimer = false;
                        this.timer = 60;
                    }
                }, 1000);
            },
        },
        computed: {
            isDisabled() {
                return this.smsCode && this.smsCode !== "";
            },
            extension() {
                return this.fontSize === "2" ? "100" : "50";
            },
        },
    };
</script>

<style lang="less" scoped>
@import "../../../assets/theme/variable.less";
.add-report-description-buttons {
    display: flex;
    justify-content: center;
    column-gap: 0.5em;
    margin-top: 1em;
}
.resend-button {
    color: #0075c2;
    border: none;
    background: none;
    cursor: pointer;
    font-size: 1rem;
    font-weight: 500;
    font-family: "Eon Brix Sans Web", "Avenir", Helvetica, Arial, sans-serif;
    width: 148px;
    &:disabled {
        cursor: auto;
        color: #8F9192;
    }
}
</style>
